import React from "react";
import isTourApiEnabled from "../../utils/isTourApiEnabled";
import LocalExperiencesTourApiPage from "./LocalExperiencesTourApi";
import LocalExperiencesLegacyPage from "./LocalExperiencesLegacy";

/**
 * Veri kaynağı seçimi TripPlan'daki BookableExperiences ile aynı kurala bağlı:
 * tourApi açık white-label'larda birleşik /tour-api/search, diğerlerinde
 * provider'ların kendi katalog API'leri.
 */
const LocalExperiencesPage = () =>
  isTourApiEnabled() ? (
    <LocalExperiencesTourApiPage />
  ) : (
    <LocalExperiencesLegacyPage />
  );

export default LocalExperiencesPage;
